import React, { Component, forwardRef, Fragment } from 'react'
import styled, { css } from 'styled-components'
import { FALIcon } from 'FAIcon'
import { FICPageSectionBlock } from 'FICPageSection'
import FICColors from 'FICColors'
import Autocomplete from './Autocomplete'
import FICTextButton from 'FICTextButton'
import FICRestV2 from 'FICRestV2'
import { Parser as HtmlToReactParser } from 'html-to-react'
import FICButton from 'common/components-v2/FICButton/FICButton'
import FICLink from 'common/components-v2/FICButton/FICLink'
import FICIcon from 'common/components-v2/FICIcon/FICIcon'

const htmlToReactParser = new HtmlToReactParser()

const IconClose = styled(FALIcon)`
	height: 40px;
	cursor: pointer;
	position: absolute;
  top:30px;
  right:34px;
  color: ${FICColors.white};
  opacity:1;
`
const Logo = styled.img`
  position: absolute;
  top:30px;
  left:34px;
`

export const MainContainer = styled.div`
  background-color: ${FICColors.white};
  border-radius: 5px;
  overflow: auto;
  height:100%;
  ${props => props.isExternal && css`
    height: calc(100% - 90px);
    @media (max-width: 425px) {
      height: calc(100% - 57px);
    }
  `};
  @supports (-ms-ime-align: auto) {
    & {border-radius: 7px;}
  }
  .embeddedArticle {
    max-width: 800px;
  }
  .embeddedSection {
    max-width: 800px;
  }
`

const HeaderSearchSectionImpl = ({ className, ...props }) => <div className={className}>
  <FICPageSectionBlock>
    {!props.isExternal && !props.embedded &&
    <h1>Supporto clienti</h1>
    }
    <div className='subtitle'>Ciao! Come possiamo aiutarti?</div>
    <Autocomplete onChange={props.onChange} onSelect={props.onSelect} isExternal={props.isExternal} realm={props.realm} />
  </FICPageSectionBlock>
</div>

const HeaderSearchSection = styled(HeaderSearchSectionImpl)`
    text-align: center;
    ${props => props.isExternal && css`
      margin-top: 60px;
      @media screen and (max-width: 799px){
        margin-top: 20px;
      }
    `};
    .fic-page-section-block{max-width: 100%}
    h1{
      height: 24px;
      color: rgba(255,255,255,0.8);
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 0.11px;
      line-height: 24px;
      margin-bottom: 60px;
      margin-top: 35px;
    }
    .subtitle {
      height: 48px;
      @media screen and (max-width: 799px){
        height: auto;
      }
      color: ${FICColors.white};
      font-size: 32px;
      font-weight: bold;
      letter-spacing: 0.17px;
      line-height: 48px;
      text-align: center;
      @media (max-width: 425px) {
        font-size: 20px;
        line-height: 30px;
      }
    }
`

const HelpHeaderImpl = ({ className, ...props }) => <div className={className}>
  {!props.embedded && <div className='topHeader'>
    {props.realm === 'fic'
      ? <Logo src='/img/logo-new-white.png' srcSet='/img/logo-new-white@2x.png 2x, /img/logo-new-white@3x.png 3x' className='logo' />
      : <Logo src='/img/logo-dipendenticloud-white.png' className='logo' />
    }
    {props.isExternal &&
    <Fragment>
      <h1 className='defaultTitle'>Supporto clienti</h1>
      <div className='accessButton'>
        <FICTextButton text='Prova Gratis' iconLeft={[ 'fal', 'rocket' ]} href={props.realm === 'fic'
          ? 'https://www.fattureincloud.it/service/form/form-registrazione/' : 'https://secure.dipendentincloud.it/login?status=register'} />
        <FICTextButton text='Accedi' iconLeft={[ 'fal', 'sign-in' ]} href={props.realm === 'fic'
          ? 'https://www.fattureincloud.it/service/form/form-login/' : 'https://secure.dipendentincloud.it/login?status=login'} />
      </div>
    </Fragment>
    }
    {props.closeIcon &&
    <IconClose name='close' onClick={() => props.onClickClose()} size={30} className='closeIcon' />
    }
  </div>}
  <HeaderSearchSection 
    onChange={props.onChange} 
    onSelect={props.onSelect} 
    isExternal={props.isExternal} 
    realm={props.realm} 
    embedded={props.embedded}
  />
</div>

export const HelpHeader = styled(HelpHeaderImpl)`
  color: ${FICColors.white};
  position: relative;
  padding-bottom: 50px;
  background: url('/img/background-faq.png');
`

const HelpHeaderDetailedImpl = forwardRef((forwardedProps, ref) => {
  const props = { ...forwardedProps }
  return (
    <div className={props.className} ref={ref}>
      {props.realm === 'fic' && !props.isExternal &&
      <FBCommunityBanner isExternal={false} />
      }
      <div className={`sectionHeader ${props.embedded ? 'embeddedHeader' : ''}`}>
        {!props.isExternal &&
        <FICTextButton iconLeft={[ 'fal', 'angle-left' ]} text='Indietro' onClick={props.onClick} />
        }
        <h1>{props.title}</h1>
        {props.description &&
        <h4 className='description'>{props.description}</h4>
        }
        {props.subtitle &&
        <div className='subtitle'>{props.subtitle}</div>
        }
        {props.closeIcon && !props.isExternal &&
        <IconClose name='close' onClick={() => props.onClickClose()} size={30} style={{ right: 0 }} />
        }
      </div>
    </div>
  )
})

export const HelpHeaderDetailed = styled(HelpHeaderDetailedImpl)`
  color: ${FICColors.white};
  position: relative;
  padding-bottom: 50px;
  min-height: 190px;
  box-sizing: border-box;
  background: url('/img/background-faq.png');
  @media (max-width: 425px) {
    padding-bottom: 25px;
    min-height: 80px;
  }
  .sectionHeader{
    margin: 0 auto;
    padding-top: 25px;
    position: relative;
    max-width: 940px;
    @media (max-width: 425px) {
      h1 {
        font-size: 20px;
        line-height: 30px;
        margin: 0;
      }
      h4 {
        font-size: 16px;
        line-height: 27px;
        margin-bottom: 0;
      }
    }
  }
  .embeddedHeader {
    max-width: 800px;
  }
  .fic-text-button {
    height: auto!important;
    max-height: unset!important;
    text-transform: none;
    width: auto;
    border-radius: 18.5px!important;
    color: ${FICColors.white};
    font-size: 18px!important;
    font-weight: 400;
    line-height: 24px;
    background-color: rgba(255,255,255,0.24);
    border:none;
    @media all and (-ms-high-contrast: none) {
      & { padding:5px 14px 14px!important; }  
   }
  }
  h1{
    color: ${FICColors.white};
    font-size: 34px;
    font-weight: bold;
    line-height: 48px;
    margin-top: 17px;
  }
  .description{
    color: ${FICColors.white};
    font-size: 16px;
    line-height: 24px;
    margin-top: 5px;
  }
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(51,51,51,0.08)
`

const ChatImpl = ({ className, ...props }) => <div className={className}>
  <h3>Non trovi quello che stai cercando?</h3>
  <div className='averageResponseTime'>
    <FALIcon name='exclamation-triangle' />
    <span>{htmlToReactParser.parse(props.warning)}</span>
  </div>
  <FICTextButton text={'Contatta l\'assistenza'} iconLeft={[ 'fal', 'envelope' ]} onClick={() => chatOpening(props.type, props.id)} />
</div>

export const Chat = styled(ChatImpl)`
margin: 50px auto;
box-sizing: border-box;
text-align: center;
padding-left: 12.5px;
padding-right: 12.5px;
  .fic-text-button{
    background-color: ${FICColors.white};
    color:${FICColors.defaultBlue};
    border:2px solid ${FICColors.defaultBlue};
    font-size: 16px!important;
    text-transform: none;
    padding: 15px!important;
    &:hover{
      color:${FICColors.white};
      background-color: ${FICColors.defaultBlue};
    }
  }
  h3{
    margin: 25px 0;
    font-size: 20px;
  }
  .averageResponseTime {
    box-sizing: border-box;
    height: auto;
    width: 640px;
    max-width: 100%;
    border: 1px solid rgba(255,141,45,0.32);
    border-radius: 4px;
    background-color: rgba(255,141,45,0.24);
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);
    margin: 30px auto;
    color: #FF8D2D;
    font-size: 16px;
    padding: 13px ;
    line-height: 23px;
    .fa, .faicon{
      display: table-cell;
      vertical-align: middle;
      padding-right: 8px;
      font-size: 23px;
    }
    span{
      display: table-cell;
      width: 100%;
    }
  }
`

const chatOpening = (type, id) => {
  customerly.open()

  FICRestV2.post({
    request: 'help/chat',
    postData: { data: { [ type + '_id' ]: id } }
  })
}

const ElementNotFoundImpl = ({ type, onClick, className }) => {
  return (
    <div className={className}>
      <img srcSet='/img/no-results.png 3x' />
      <div style={{ margin: '20px 0' }}>{type === 'section' ? 'La sezione cercata non esiste.' : 'L\'articolo cercato non esiste.'}</div>
      <FICButton text='Torna alla home' onClick={onClick} />
    </div>
  )
}

export const ElementNotFound = styled(ElementNotFoundImpl)`
  max-width: 940px;
  margin: 0 auto;
  padding: 24px 0;
  font-size: 16px;
  text-align: center;
`

export class FBCommunityBanner extends Component {
  constructor (props) {
    super(props)
    this.state = { isFacebookBannerVisible: false }
  }

  componentDidMount () {
    this.setState({ isFacebookBannerVisible: !(localStorage.getItem('helpFacebookBannerIsVisible')) })
  }

  goToFBPage = () => {
    window.open('http://bit.ly/fic-fb', '_blank')
    this.hideFacebookBanner()
  }

  hideFacebookBanner = () => {
    localStorage.setItem('helpFacebookBannerIsVisible', 'false')
    this.setState({ isFacebookBannerVisible: false })
  }

  render () {
    return (
      <FBCommunityBannerContainer
        isVisible={this.state.isFacebookBannerVisible}
        isExternal={this.props.isExternal}
      >
        <div>
          <img src='/img/logo-fb-circle.png' alt='facebook-logo' />
          <span>
            Migliaia di utenti utilizzano la nostra community su Facebook per aiutarsi tra di loro e per ricevere supporto.
            <FICLink
              target='_blank'
              onClick={() => {
                this.goToFBPage()
              }}
              text='Iscriviti anche te!'
              style={{ marginLeft: 5 }}
            />
          </span>
          <FICIcon
            name={'times'}
            onClick={() => {
              this.hideFacebookBanner()
            }}
          />
        </div>
      </FBCommunityBannerContainer>
    )
  }
}

const FBCommunityBannerContainer = styled.div`
  background-color: ${FICColors.lightGray};
  color: ${FICColors.textDefault};
  top: 0;
  z-index: 102;
  width: 100%;
  transition: max-height 500ms;
  max-height: 0;
  overflow: hidden;
  ${props => props.isVisible && css`
    max-height: 200px;
  `}
  >div{
    max-width: 1080px;
    ${props => props.isExternal && css`
      max-width: 1200px;
    `};
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 12px;
    
    @media (max-width: 425px) {
      align-items: start;
    }
  }
  img{
    display: block;
    height: 16px;
    margin-right: 12px;
  }
  span {
  flex: 1;
  }
  .Icon{
    cursor: pointer;
    margin-left: 12px;
    justify-self: right;
  }
`

const PrivacyMessageImpl = ({ className, isFic }) => {
  return (
    <div className={className}>
      {isFic
        ? <Fragment>Fatture in Cloud è finalizzato a consentire il trattamento dei Dati Personali strettamente necessari ai fini della gestione degli adempimenti contabili e amministrativi relativi alle fatture elettroniche. Tale trattamento richiede che Fatture in Cloud sia utilizzato in conformità con i principi di minimizzazione, integrità e riservatezza previsti dalla normativa in materia di protezione dei dati personali applicabile, ad esempio limitando la descrizione della prestazione professionale svolta a quanto strettamente necessario a fini fiscali per evitare di includere dati di minori o relativi a prestazioni sanitarie, condanne penali e reati
        </Fragment>
        : <Fragment>Dipendenti in Cloud è finalizzato a consentire il trattamento dei Dati Personali strettamente necessari ai fini della gestione degli adempimenti relativi alla gestione dei dipendenti. Tale trattamento richiede che Dipendenti in Cloud sia utilizzato in conformità con i principi di minimizzazione, integrità e riservatezza previsti dalla normativa in materia di protezione dei dati personali applicabile.
        </Fragment>
      }
    </div>
  )
}

export const PrivacyMessage = styled(PrivacyMessageImpl)`
  max-width: 640px;
  color: #6F7E86;
  font-size: 10px;
  margin: 0 auto 40px;
  line-height: 15px;
  @media (max-width: 425px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`



// WEBPACK FOOTER //
// ./src/help/common/customComponents.js